export const BREAKPOINT_SMALL = '@media (max-width: 400px)'
export const BREAKPOINT_MOBILE = '@media (max-width: 850px)'
export const BREAKPOINT_DESKTOP = '@media (min-width: 850px)'
